import BrButton from '@govbr/react-components/lib/BrButton';
import { Dialog, DialogContent, DialogContentText, Grid } from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { calcularTempoRestanteDecursoPrazo } from '../../../../common/DateUtil';
import { formatarNit } from '../../../../common/formatadores';
import Accordion from '../../../../components/Accordion/Accordion';
import FieldGroup from '../../../../components/FieldGroup/FieldGroup';
import Message from '../../../../components/Message/Message';
import { TipoPerfil } from '../../../../model/TipoPerfil';
import { selectPerfilCompleto } from '../../../Perfil/perfilSlice';
import { getDetalhesMembro, selectMembrosFamiliares } from '../../consultaCompletaSlice';
import styles from './MembrosFamiliares.module.css';
import { TipoMensagemBanner, selectBannerInfo } from '../../../../components/DadosBasicos/dadosBasicosSlice';
import { trackServiceSelect } from '../../../../common/tracker';
import { getDecursoPrazo, selectDecursoPrazo } from '../../../Suporte/SuporteSlice';

const MembrosFamiliares: React.FC<any> = (props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();

  const membrosFamiliares: any[] = useAppSelector(selectMembrosFamiliares);
  const perfil = useAppSelector(selectPerfilCompleto);

  const [infoExclusaoObitoOpen, setInfoExclusaoObitoOpen] = useState(false);

  const bannerInfo = useAppSelector(selectBannerInfo);

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  useEffect(() => {
    dispatch(getDecursoPrazo());
  },[])

  const detalharMembro = async (id: number) => {
    await dispatch(getDetalhesMembro(id));
    const rootEl = document.getElementById('root');
    rootEl?.scrollTo(0, 0);
  };

  const mostrarParentesco = (membro: any) => {
    if (membro?.tipoRelacaoParentescoRF?.nome === 'Pessoa Responsável pela Unidade Familiar - RF') {
      return 'Responsável Familiar - RF';
    }
    return membro?.tipoRelacaoParentescoRF?.nome;
  };

  const permitirAlertaVermelho = (membro: any) => {
    let alertar = false;

    if (!temSolicitacaoExclusaoDeObito(membro)) {
      alertar = indicacaoDeObito(membro);
    } else if (isFamiliaCadastradaEIntegranteEmCadastramento(membro.pessoaDadosCadastroDTO)) {
      alertar = false;
    }

    return alertar;
  };

  const permitirAlertaAmarelo = (dadosCadastraisMembro: any, membro: any) => {
    return (!permitirAlertaVermelho(membro) && perfil?.tipoEstadoCadastralFamilia?.codigo === 3 && dadosCadastraisMembro?.tipoEstadoCadastralMembro?.codigo === 1) ||
    (!permitirAlertaVermelho(membro) && temSolicitacaoExclusaoDeObito(membro));
  };

  const isFamiliaCadastradaEIntegranteEmCadastramento = (dadosCadastraisMembro: any) => {
    return perfil?.tipoEstadoCadastralFamilia?.codigo === 3 && dadosCadastraisMembro?.tipoEstadoCadastralMembro?.codigo === 1;
  };

  const isFamiliaCadastrada = () => {
    return perfil?.tipoEstadoCadastralFamilia?.codigo === 3;
  };

  const indicacaoDeObito = (membro: any) => {
    return membro.obito;
  };

  const temSolicitacaoExclusaoDeObito = (membro: any) => {
    return membro.solicitacaoExclusaoObito;
  };

  // Ver esse método, pois tem RF com óbito. Criado outro abaixo
  const rfEstaEmObito = () => {
    return !membrosFamiliares.some(membro => membro.isResponsavelFamiliar && membro.obito);
  };

  const rfPossuiObito = () => {
    return membrosFamiliares.some(membro => membro.isResponsavelFamiliar && membro.obito);
  }

  const temRF = () => {
    return membrosFamiliares.some(membro => membro.isResponsavelFamiliar);
  };

  const mensagemSolicitacaoExclusaoObito = () => {
    return <>
      Integrante familiar excluído por motivo de falecimento. Acesse o cadastro daqui a 1 dia útil para confirmar que a exclusão foi efetuada com sucesso.
      Caso a exclusão não tenha sido realizada, procure o CRAS ou posto de atendimento do Cadastro Único para maiores esclarecimentos.
    </>
  };

  const mensagemObito = (membro: any) => {
    if (membro.isResponsavelFamiliar) {
      return <>
        O responsável familiar está com registro de falecimento.<br/>
        Alguma pessoa da família deve ir ao CRAS atualizar o Cadastro Único.
      </>;
    }

    // testes para visualização da mensagem de falecimento por integrante não responsável familiar
    //código retirado: perfil?.tipoPerfil?.codigo === TipoPerfil.RESPONSAVEL_FAMILIAR) && corpo do if
    if (!perfil.temRL &&
        (
          (bannerInfo?.tipoMensagemBanner.codigo == TipoMensagemBanner.FAMILIA_SEM_RF ||
          bannerInfo?.tipoMensagemBanner.codigo == TipoMensagemBanner.FAMILIA_COM_MAIS_DE_UM_RF)
          || !isFamiliaCadastrada()
          || (!membro?.isResponsavelFamiliar && rfPossuiObito())
        )
      ) {
      return <>
        Pessoa com registro de falecimento.<br/>
        O responsável familiar deve ir ao CRAS para atualizar o Cadastro Único.<br/>
        Se o Cadastro Único não for atualizado, esta pessoa será excluída da família.
      </>;
    }

    if (perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL ||
        (perfil?.tipoPerfil?.codigo === TipoPerfil.INTEGRANTE_FAMILIAR && perfil.temRL)) {
      return <>
        Pessoa com registro de falecimento.<br/>
        O representante legal deve ir ao CRAS para atualizar o Cadastro Único.<br/>
        Se o Cadastro Único não for atualizado, esta pessoa será excluída da família.
      </>;
    }

    if (perfil?.tipoPerfil?.codigo === TipoPerfil.INTEGRANTE_FAMILIAR && temRF() ||
        perfil?.tipoPerfil?.codigo === TipoPerfil.INTEGRANTE_FAMILIAR && !perfil.temRL) {
     return <>
        Pessoa com registro de falecimento.
        <br/>
        O responsável familiar deve tratar a pendência no aplicativo ou ir ao CRAS para atualizar o Cadastro Único.
        {/** O responsável familiar deve ir ao CRAS para atualizar o Cadastro Único. <br/>
        Se o Cadastro Único não for atualizado, esta pessoa será excluída da família.*/}
      </>
    }

    return <>
      <div onClick={() => setInfoExclusaoObitoOpen(true)}>
        Pessoa com registro de falecimento.
        <br/>
        O responsável familiar deve realizar a exclusão cadastral da pessoa clicando no botão de tratar pendência.
        Se a pessoa estiver viva <span className={styles.textoClicavel}>clique aqui</span>&nbsp; para orientações.
        {/**Pessoa com registro de falecimento.
        <br/>
        O responsável familiar deve ir ao CRAS para atualizar o Cadastro Único.<br/>
        Se o Cadastro Único não for atualizado, esta pessoa será excluída da família.*/}
      </div>
    </>;
  };

  const navegarExclusaoIntegrantePorObito = () => {
    trackServiceSelect('POR-MENU', "EXCLUSÃO INTEGRANTE FAMÍLIA POR MOTIVO DE ÓBITO");
    if (localStorage.getItem('cadunico/tutorial-exclusao-por-obito-nao-exibir') === 'true') {
      history.push('/exclusaoPorObito');
    } else {
      history.push('/exclusaoPorObito/tutorial');
    }
  };

  return (
    <>
      {membrosFamiliares.map((membro, index) => {
        const dadosCadastrais = membro.pessoaDadosCadastroDTO;
        return (
          <Accordion
            id={`membro-${index}`}
            title={(dadosCadastrais.temIdentidadeGenero === 1 && dadosCadastrais.nomeSocialApelidoPessoa) ? dadosCadastrais.nomeSocialApelidoPessoa : dadosCadastrais?.nomePessoa}
            subtitle={mostrarParentesco(membro)}
            key={index}
            open={!props.location?.state?.mostrarIntegrantes || indicacaoDeObito(membro)}
            className={`${permitirAlertaVermelho(membro) ? styles.alertCard : ''} ${permitirAlertaAmarelo(membro.pessoaDadosCadastroDTO, membro) ? styles.warnCard : ''}`}
          >
            {indicacaoDeObito(membro) && !temSolicitacaoExclusaoDeObito(membro) &&(
              <>
                <Message
                  type={'error'}
                  text={mensagemObito(membro)}
                  textBold={true}
                  title={`ATENÇÃO!`}
                  className={styles.message}
                />
                <p />
              </>
            )}
            {/**indicacaoDeObito(membro) && temSolicitacaoExclusaoDeObito(membro) && (
              <>
                <Message
                  type={'warning'}
                  text={mensagemSolicitacaoExclusaoObito()}
                  className={styles.message}
                />
                <p />
              </>
            )*/}
            {!indicacaoDeObito(membro) && isFamiliaCadastradaEIntegranteEmCadastramento(dadosCadastrais) && (
              <>
                <Message
                  type={'warning'}
                  title={`O cadastro dessa pessoa está incompleto. Caso deseje complementar, o ${perfil.temRF ? "responsável familiar" : "representante legal"} deve comparecer ao posto de cadastramento em até ${calcularTempoRestanteDecursoPrazo(
                    dadosCadastrais.dataCadastramentoPessoa, decursoPrazo
                  )} dias, ou o cadastro dessa pessoa será excluído.`}
                  className={styles.message}
                />
                <p />
              </>
            )}

            <Grid container spacing={2}>
              {perfil?.temRF && (
                <Grid item xs={12}>
                  <FieldGroup
                    label="Parentesco com o(a) RF"
                    value={mostrarParentesco(membro)}
                    size="sm"
                  />
                </Grid>
              )}
              <Grid item xs={6} sm={3}>
                <FieldGroup
                  label="Estado cadastral"
                  value={dadosCadastrais?.tipoEstadoCadastralMembro?.nome}
                  size="sm"
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <FieldGroup
                  label="NIS, PIS ou PASEP"
                  value={formatarNit(dadosCadastrais?.numeroNisPisPasepPessoa)}
                  size="sm"
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <FieldGroup
                  label="Data de nascimento"
                  value={
                    dadosCadastrais?.dataNascimentoPessoa
                      ? moment(dadosCadastrais?.dataNascimentoPessoa).format('DD/MM/YYYY')
                      : null
                  }
                  size="sm"
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <FieldGroup label="Sexo" value={dadosCadastrais?.tipoSexoPessoa?.nome} size="sm" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FieldGroup
                  label="Filiação 1 (ou nome completo da mãe)"
                  value={dadosCadastrais?.filiacao1}
                  size="sm"
                  emptyValue="Não sabe"
                />
              </Grid>
            </Grid>
            <div className={styles.cardFooter}>
              {(perfil?.tipoPerfil?.codigo === TipoPerfil.RESPONSAVEL_FAMILIAR ||
                perfil?.tipoPerfil?.codigo === TipoPerfil.REPRESENTANTE_LEGAL ||
                perfil?.identificador === membro.identificador) && (
                <BrButton
                  className={`${styles.botao} ${styles.secundario}`}
                  onClick={() => detalharMembro(membro.identificador)}
                >
                  Detalhar dados da pessoa
                </BrButton>
              )}

              {bannerInfo?.tipoMensagemBanner.codigo !== TipoMensagemBanner.FAMILIA_SEM_RF &&
                bannerInfo?.tipoMensagemBanner.codigo !== TipoMensagemBanner.FAMILIA_COM_MAIS_DE_UM_RF &&
                  rfEstaEmObito() && !temSolicitacaoExclusaoDeObito(membro) && (perfil?.tipoPerfil?.codigo === TipoPerfil.RESPONSAVEL_FAMILIAR &&
                  indicacaoDeObito(membro)) && isFamiliaCadastrada() && (
                  <BrButton
                    className={`${styles.botao}`}
                    onClick={() => navegarExclusaoIntegrantePorObito()}
                  >
                    Tratar pendência
                  </BrButton>
              )}
            </div>
          </Accordion>
        );
      })}

      <Dialog open={infoExclusaoObitoOpen} onClose={() => setInfoExclusaoObitoOpen(false)}>
        <DialogContent>
          <DialogContentText>
            <span className={styles.textoDialogo}>
              Caso a pessoa esteja viva, ou seja, o indicativo de falecimento está errado, é
              preciso que o RF da família compareça ao CRAS ou posto de atendimento do
              Cadastro Único, no seu município, para realizar a atualização cadastral.
              <br/><br/>
              Ele deve levar a documentação de identificação de todos os integrantes da
              família.
            </span>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MembrosFamiliares;
